'use client';

import { useHasUnreadBonus } from '../model/useHasUnreadBonus';
import { ScPromoDot } from './styled';

export const PromoDot = () => {
  const hasUnreadBonus = useHasUnreadBonus();

  if (!hasUnreadBonus) return null;

  return <ScPromoDot aria-hidden="true" />;
};
